import { graphql } from 'GQL/gql';

const QUERY = graphql(`
  query GLOBAL_SEARCH(
    $text: String!
    $limit: Int
    $isCompanySpecific: Boolean
    $types: [FilterGlobalSearchTypes]
    $language: Language
    $organizationId: ID
    $indirect: Boolean
    $isSkillInventory: Boolean
    $isSharedSkillsOnly: Boolean
    $isPrioritizingCompanySpecific: Boolean
    $isSearchingWholeCompany: Boolean
    $companyOpportunityType: CapabilityTypeEnum
    $bypassCustomerSpecificSynonyms: Boolean
    $viewEntireOrganization: Boolean
  ) {
    search(
      text: $text
      companyOpportunityType: $companyOpportunityType
      limit: $limit
      types: $types
      isCompanySpecific: $isCompanySpecific
      language: $language
      organizationId: $organizationId
      indirect: $indirect
      isSkillInventory: $isSkillInventory
      isSharedSkillsOnly: $isSharedSkillsOnly
      isPrioritizingCompanySpecific: $isPrioritizingCompanySpecific
      isSearchingWholeCompany: $isSearchingWholeCompany
      bypassCustomerSpecificSynonyms: $bypassCustomerSpecificSynonyms
      viewEntireOrganization: $viewEntireOrganization
    ) {
      ... on SkillSynonymGlobalSearch {
        __typename
        _id
        companySpecific {
          _id
          isLogoVisible
          customName
        }
        skillId
        synonymString
        synonymLang
        synonymId
        associatedSkillName
        skill {
          _id
          trends {
            _id
            trendIcon
          }
          source
          type
        }
        synonymLevelDescriptions {
          _id
          level
          description
        }
      }
      ... on JobSynonym {
        __typename
        _id
        name
        trendIcon
      }
      ... on CompanyOpportunity {
        __typename
        _id
        name
      }
    }
  }
`);

export default QUERY;
